"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configs_1 = require("./configs");
var NCAABConfig = {
    id: "735cf219-4ffc-4ca0-8307-ed94853df175",
    name: "NCAAB",
    url: "ncaab",
    tabName: "NCAAB",
    icon: "football",
    imagePath: "NCAA",
    key: "CBK",
    lookupKey: "ncaab",
    favoriteLine: "spread",
    hasTeamPowerProjectionGrades: true,
    hasFGspreadPowerRating: true,
    hasFGmoneylinePowerRating: true,
    hasFGtotalPowerRating: true,
    has1HspreadPowerRating: true,
    has1HmoneylinePowerRating: true,
    has1HtotalPowerRating: true,
    has1PspreadPowerRating: false,
    has1PmoneylinePowerRating: false,
    has1PtotalPowerRating: false,
    hasPitchers: false,
    hasGoals: false,
    hasInjuries: false,
    hasNews: false,
    hasLineup: false,
    hasSchedule: true,
    hasConfiguredSchedule: false,
    hasTeamSummary: true,
    hasGameFilters: true,
    hasStadium: true,
    hasLocation: true,
    hasTeamRecord: true,
    hasApRank: true,
    hasConferenceDropdown: true,
    hasNewsInjuriesColumn: false,
    hasDraws: false,
    hasSharpData: true,
    hasTopTrendsData: true,
    hasPlayerProps: false,
    hasRecommendedBets: true,
    hasPopularEvents: true,
    isCollege: true,
    defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
    defaultColumnOrder: [2, 5, 9, 15, 4],
    publicThreshold: 65,
    sharpPercentThreshold: 30,
    sharpCountThreshold: 200,
    publicCountThreshold: 200,
    trendTypes: configs_1.DEFAULT_TREND_TYPES,
    filters: [
        {
            name: "Spread",
            key: "spread",
            url: "spread",
        },
        {
            name: "Moneyline",
            key: "moneyline",
            url: "moneyline",
        },
        {
            name: "Total",
            key: "total",
            url: "totals-spread",
        },
        {
            name: "1st Half Spread",
            key: "1Hspread",
            url: "first-half-lines",
        },
        {
            name: "1st Half Moneyline",
            key: "1Hmoneyline",
            url: "first-half-moneyline",
        },
        {
            name: "1st Half Total",
            key: "1Htotal",
            url: "first-half-totals-spread",
        },
        {
            name: "2nd Half Spread",
            key: "2Hspread",
            url: "second-half-lines",
        },
        {
            name: "2nd Half Moneyline",
            key: "2Hmoneyline",
            url: "second-half-moneylines",
        },
    ],
    periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
    periodKeys: ["FG", "1H", "2H"],
    pickTypes: [
        "spread",
        "moneyline",
        "total",
        "1Hspread",
        "1Hmoneyline",
        "1Htotal",
        "2Hspread",
        "2Hmoneyline",
    ],
    conferenceList: [
        {
            name: "NCAA Tournament",
            key: "NCAAT",
            url: "ncaa-tournament",
        },
        {
            name: "NIT Tournament",
            key: "NIT",
            url: "nit-tournament",
        },
        {
            name: "CBI Tournament",
            key: "CBI",
            url: "cbi-tournament",
        },
        {
            name: "The Basketball Classic",
            key: "TBC",
            url: "the-basketball-classic",
        },
        {
            name: "All Conferences",
            key: "ALL",
            url: "all",
        },
        {
            name: "Top 25",
            key: "TOP25",
            url: "top-25",
        },
        {
            name: "America East",
            key: "AMEAST",
            url: "america-east",
        },
        {
            name: "American",
            key: "AAC",
            url: "american",
        },
        {
            name: "Atlantic 10",
            key: "A10",
            url: "atlantic-10",
        },
        {
            name: "Atlantic Coast",
            key: "ACC",
            url: "atlantic-coast",
        },
        {
            name: "Atlantic Sun",
            key: "ASUN",
            url: "atlantic-sun",
        },
        {
            name: "Big 12",
            key: "B12",
            url: "big-12",
        },
        {
            name: "Big East",
            key: "BEC",
            url: "big-east",
        },
        {
            name: "Big Sky",
            key: "BSC",
            url: "big-sky",
        },
        {
            name: "Big South",
            key: "BIGSOUTH",
            url: "big-south",
        },
        {
            name: "Big Ten",
            key: "B1G",
            url: "big-ten",
        },
        {
            name: "Big West",
            key: "BWC",
            url: "big-west",
        },
        {
            name: "Colonial",
            key: "CAA",
            url: "colonial",
        },
        {
            name: "Conference USA",
            key: "CUSA",
            url: "conference-usa",
        },
        {
            name: "Horizon League",
            key: "HORIZON",
            url: "horizon-league",
        },
        {
            name: "Ivy League",
            key: "IVY",
            url: "ivy-league",
        },
        {
            name: "Metro Atlantic Athletic",
            key: "MAAC",
            url: "metro-atlantic-athletic",
        },
        {
            name: "MAC",
            key: "MAC",
            url: "mac",
        },
        {
            name: "MEAC",
            key: "MEAC",
            url: "meac",
        },
        {
            name: "Missouri Valley",
            key: "MVC",
            url: "missouri-valley",
        },
        {
            name: "Mountain West",
            key: "MWC",
            url: "mountain-west",
        },
        {
            name: "Northeast",
            key: "NEC",
            url: "northeast",
        },
        {
            name: "Ohio Valley",
            key: "OVC",
            url: "ohio-valley",
        },
        {
            name: "Pac-12",
            key: "P12",
            url: "pac-12",
        },
        {
            name: "Patriot League",
            key: "PATRIOT",
            url: "patriot-league",
        },
        {
            name: "SEC",
            key: "SOUTHEASTERN",
            url: "sec",
        },
        {
            name: "Southern",
            key: "SOCON",
            url: "southern",
        },
        {
            name: "Southland",
            key: "SOUTHLAND",
            url: "southland",
        },
        {
            name: "Southwestern Athletic",
            key: "SWAC",
            url: "southwestern-athletic",
        },
        {
            name: "Summit",
            key: "SUMMIT",
            url: "summit",
        },
        {
            name: "Sun Belt",
            key: "SBC",
            url: "sun-belt",
        },
        {
            name: "West Coast",
            key: "WCC",
            url: "west-coast",
        },
        {
            name: "WAC",
            key: "WAC",
            url: "wac",
        },
    ],
};
exports.default = NCAABConfig;

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
